const MoveArrowIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M12.3 9.3L8.5 13.1V1H7.5V13.1L3.7 9.3L3 10L8 15L13 10L12.3 9.3Z'
        fill='#1D262E'
        fillRule='evenodd'
      />
    </svg>
  );
};

export default MoveArrowIcon;
